import React, { useContext, useEffect } from 'react';
import { Flex, Button, Card, Typography, Divider, Alert } from 'antd';

import { Course } from '../Course';
import { Supervision } from '../Course_supervision';

import _ from 'lodash';
import { semesterStruct } from './struct';
import { IsFormSaved } from '../../../../../../context/FromStatusContext';
import { useSelector } from 'react-redux';
import { semesterLabel } from '../../../../../../const/semesterLabel';

const { Title, Paragraph } = Typography;

export const Semester = ({
  semesterDetail,
  updateTeaching,
  updateSupervision,
  updatePlaning,
  semesterLoading,
  status,
  semesterComments
}) => {
  const { setIsFormSaved } = useContext(IsFormSaved);

  const _static = useSelector((state) => state.static);
  const { staticData } = _static;

  const { evaluation_status: evaluationStatus } = staticData;

    const underloadMessage =
    semesterDetail['underload'] || semesterDetail.underload || null;


  const {
    semester,
    apa_point,
    teaching,
    supervision,
    originalTeaching,
    originalSupervision
  } = semesterDetail;

  const teachingCourses = teaching || [];
  const supervisionCourses = supervision || [];

  useEffect(() => {
    const isEqual =
      _.isEqual(originalTeaching, teaching) && _.isEqual(originalSupervision, supervision);

    if (isEqual) {
      setIsFormSaved(true);
    } else {
      setIsFormSaved(false);
    }
  }, [teaching, supervision, originalTeaching, originalSupervision]);

  useEffect(() => {
    setIsFormSaved(true);
  }, []);

  return (
    <Card {...semesterStruct.wrapper}>
      <Flex {...semesterStruct.header}>
        <Title {...semesterStruct.title}>Semester~{semesterLabel(semester)}</Title>

        {evaluationStatus?.filter((e) => e.value === status)?.length > 0 && (
          <Title {...semesterStruct.title}>
            Status~
            {evaluationStatus?.filter((e) => e.value === status)?.[0]?.label}
          </Title>
        )}
      </Flex>

            {underloadMessage ? (
        <>
          <br />
          <Alert
            type="warning"
            showIcon
            message="Underload Warning"
            description={underloadMessage}
          />
        </>
      ) : (
        <></>
      )}

      <br />

      {semesterComments && semesterComments[semester] && (
        <Paragraph>
          <strong>Comment:</strong> {semesterComments[semester]}
        </Paragraph>
      )}

      {/* Table A ~ Teaching Evaluation */}
      <Title level={5} style={{ marginBottom: 12}}>
        Teaching Evaluation
      </Title>
      <Course
        courses={teachingCourses}
        updateSemester={updateTeaching}
        semesterName={semester}
        apaPoint={apa_point}
        status={status}
      />

      <Divider style={{ margin: '20px 0' }} />

      {/* Table B ~ Supervision */}
      <Title level={5} style={{ marginBottom: 12 }}>
        Supervision
      </Title>
      <Supervision
        courses={supervisionCourses}
        updateSemester={updateSupervision}
        semesterName={semester}
        apaPoint={apa_point}
        status={status}
      />

      <Typography.Text
        type="secondary"
        style={{ display: 'block', marginTop: 8, fontSize: 12, color: '#27be6b' }}
      >
        <strong>Note:</strong>
        <br />
        1. Save after every change <br />
        2. The form will be locked after end of evaluation period.
      </Typography.Text>

      <Flex justify="end" gap={10}>
        <Button
          {...semesterStruct.saveButton}
          loading={semesterLoading[semester]?.updateLoading}
          onClick={() => updatePlaning(semester)}
          disabled={status === 1 || status === 2 || status === 3}
        >
          Save
        </Button>
      </Flex>
    </Card>
  );
};